import { Component, h, Prop, Event, EventEmitter, State } from "@stencil/core";
import { type FormEvent, Newsletter } from "../types";
import AuthHeader from "../auth-header";
import { TERMS_URLS, PRIVACY_URLS } from "../../../utils/constants";
import { i18n } from "../../../utils/i18n";
import { subscribeToNewsletters } from "../../../components/hd-auth/requests"

const VIDEOS = {
  subscription: "https://assets.adsttc.com/piano/videos/illustration-subcriptions-l.mp4",
  subscription_dark: "https://assets.adsttc.com/piano/videos/illustration-subcriptions-d.mp4"
};

@Component({
  tag: 'hd-newsletters',
  styleUrl: './hd-newsletters.pcss',
  shadow: false
})
export class HdNewsletters {
  @Prop() newsletters: Newsletter[] = [];
  @Prop() site: string = 'us';
  @Prop() selectedNewsletters: string[] = [];
  @Prop() onClose: (e?: Event) => void;
  @Prop() url: string;

  @State() validForm: boolean = false;
  @State() checkTermsAgreement: boolean = false;
  @State() subscribed: boolean = false;

  @Event() prevStep: EventEmitter<FormEvent>;
  @Event() newslettersChanged: EventEmitter<string[]>;
  @Event() closeReason: EventEmitter<string>;

  t = i18n.get("hd-auth");

  private submit = async (e: Event) => {
    e.preventDefault();
    if (this.validForm) {
      await this.subscribeToAllNewsletters();
      this.closeReason.emit('subscribed_to_newsletters');
      this.onClose(e);

      /* const body = {
        newsletters: this.selectedNewsletters,
        subscribed_at: new Date()
      } */
    }
  }

  private notSubscribedEvent = (e: Event) => {
    this.closeReason.emit('remind_me_later')
    this.onClose(e)
  }

  private subscribeToAllNewsletters = async () => {
    try {
      const res = await subscribeToNewsletters(this.url);

      if (!res) {
        console.log("Error trying to subscribe to newsletters");
        return false
      }
      return true
    } catch (error) {
      console.error("Error subscribing to Newsletters", error)
    }
  }

  // private handleNewsletterSelection = (id: string) => {
  //   let newSelectedNewsletters: string[];

  //   if (this.selectedNewsletters.includes(id)) {
  //     newSelectedNewsletters = this.selectedNewsletters.filter(n => n !== id);
  //   } else {
  //     newSelectedNewsletters = [...this.selectedNewsletters, id];
  //   }
  //   this.newslettersChanged.emit(newSelectedNewsletters);
  //   this.validateForm(newSelectedNewsletters);
  // }

  // private validateForm = (selected) => {
  //   this.validForm = selected.length > 0 && this.checkTermsAgreement;
  // }

  private handleTermsChange = (e: Event) => {
    const target = e.target as HTMLInputElement;
    this.checkTermsAgreement = target.checked;
    this.validForm = this.checkTermsAgreement
    // this.validateForm(this.selectedNewsletters);
  }

  render() {
    return <form class="form-container step-container newsletters" onSubmit={this.submit}>
      <AuthHeader
        title={this.t('newsletters.title')}
        subhead={this.t('newsletters.subtitle')}
      />
      <video muted autoplay loop playsInline style={{ height: "230px" }}>
        <source src={VIDEOS["subscription_dark"]} type="video/mp4" media="(prefers-color-scheme: dark)" />
        <source src={VIDEOS['subscription']} type="video/mp4" />
      </video>
      <section class='newsletters-terms'>
        <input
          type='checkbox'
          id='terms'
          name='terms'
          checked={this.checkTermsAgreement}
          onChange={(e) => this.handleTermsChange(e)}
          required
        />
        <p>{this.t('newsletters.agree_terms_1')} <a target='_blank' href={TERMS_URLS} rel='noopener noreferrer'>{this.t('newsletters.terms_link')}</a> {this.t('newsletters.agree_terms_2')} <a target='_blank' href={PRIVACY_URLS} rel='noopener noreferrer'>{this.t('newsletters.privacy_link')}</a> </p>
      </section>
      <section class="step-actions">
        <button class="next-step" type="submit" disabled={!this.validForm}>
          {this.t('newsletters.button')}
        </button>
        <p class='remind-me'>{this.t('newsletters.or')} <a href='#' onClick={this.notSubscribedEvent}>{this.t('newsletters.remind_me')}</a></p>
      </section>

      {/* Replace when the newsletter handling logic is ready on kenneth */}
      {/* <AuthHeader
        title="Personalize Your Newsletter Subscriptions"
        subhead="Select the updates you want to receive. From quick highlights to exclusive features, tailor your inbox to your professional and creative needs."
      />

      <div class="form-body">
        {this.newsletters.map(newsletter => (
          <div class={`newsletter-pill ${this.selectedNewsletters.includes(newsletter.id) ? 'active' : ''}`}>
            <label
              key={newsletter.id}
              class='newsletter-pill-container'
            >
              <span class='newsletter-pill-content'>
                <input
                  type="checkbox"
                  value={newsletter.id}
                  checked={this.selectedNewsletters.includes(newsletter.id)}
                  onChange={() => this.handleNewsletterSelection(newsletter.id)}
                  class="visually-hidden"
                  id={newsletter.id}
                />
                <h3>{newsletter.name}</h3>
                <p>{newsletter.description}</p>
              </span>
              <div class='newsletter-pill-selector'>
                <span class={`${this.selectedNewsletters.includes(newsletter.id) ? 'active' : ''}`}></span>
              </div>
            </label>
          </div>
        ))}
      </div>
      <div class='newsletters-terms'>
        <input
          type='checkbox'
          id='terms'
          name='terms'
          checked={this.checkTermsAgreement}
          onChange={(e) => this.handleTermsChange(e)}
          required
        />
        <p>I agree to the <a target='_blank' href={TERMS_URLS} rel="noopener noreferrer">Terms of use</a> and the <a target='_blank' href={PRIVACY_URLS} rel="noopener noreferrer">Privacy Policy</a></p>
      </div>
      <div class="step-actions">
        <button class="prev-step" onClick={() => this.prevStep.emit()}>
          Previous
        </button>
        <button class="next-step" type="submit" disabled={!this.validForm}>
          Join ArchDaily
        </button>
      </div> */}
    </form >
  }
}